
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinvimannagar() {



    const cardData =
    {
        keyword: 'Urbania on rent in Viman Nagar Pune   ',
        heading: 'Amruta Travels: Urbania on rent in Viman Nagar Pune',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Viman Nagar Pune, providing a premium and comfortable solution for group travel, including corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities for a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures your Urbania rental in Viman Nagar Pune is safe, reliable, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania on rent in Viman Nagar Pune",
    "description": "Urbania on rent in Viman Nagar Pune offering premium and comfortable group travel solutions. Ideal for airport transfers, corporate travel, family trips, weddings, and outstation journeys with fully air-conditioned interiors, plush pushback seating, ample legroom, large luggage space, clean cabins, and professional drivers ensuring smooth, safe, and timely travel."
  },
  {
    "name": "Force Urbania on rent Viman Nagar",
    "description": "Force Urbania on rent in Viman Nagar providing luxury mini bus services for business and leisure travel. Well-maintained AC vehicles with spacious interiors, comfortable seating, excellent suspension, and experienced drivers familiar with airport and city routes."
  },
  {
    "name": "Urbania rental service Viman Nagar",
    "description": "Urbania rental service in Viman Nagar offering reliable, flexible, and affordable transport for corporate offices, families, and tourists. AC comfort, clean interiors, ample luggage space, and punctual professional drivers."
  },
  {
    "name": "Urbania van hire in Viman Nagar",
    "description": "Urbania van hire in Viman Nagar for small and medium-sized groups. Perfect for airport pickup-drop, meetings, events, and tours with air-conditioned comfort, spacious seating, and smooth ride quality."
  },
  {
    "name": "Urbania on rent Near Viman Nagar",
    "description": "Urbania on rent near Viman Nagar with quick availability and doorstep pickup. Suitable for IT professionals, travelers, and families seeking luxury, comfort, and reliable service."
  },
  {
    "name": "Urbania on rent near Pune Airport",
    "description": "Urbania on rent near Pune Airport for hassle-free airport transfers. Spacious AC interiors, luggage-friendly design, and drivers experienced with airport schedules ensure stress-free travel."
  },
  {
    "name": "Urbania Pune Airport pickup Viman Nagar",
    "description": "Urbania Pune Airport pickup service in Viman Nagar offering timely arrivals, ample luggage space, and AC comfort for families, corporate guests, and group travelers."
  },
  {
    "name": "Urbania Pune Airport drop Viman Nagar",
    "description": "Urbania Pune Airport drop service from Viman Nagar with punctual departures, luxury AC interiors, and professional chauffeurs ensuring a smooth airport commute."
  },
  {
    "name": "Force Urbania airport transfer Viman Nagar",
    "description": "Force Urbania airport transfer service in Viman Nagar for premium pickup and drop. Ideal for executives, families, and guests with spacious seating, AC comfort, and reliable drivers."
  },
  {
    "name": "Urbania van hire Viman Nagar Airport",
    "description": "Urbania van hire near Viman Nagar Airport for group airport transportation. Comfortable AC interiors, ample luggage capacity, and trained drivers ensure seamless airport travel."
  },
  {
    "name": "13 seater Urbania on rent Viman Nagar",
    "description": "13 seater Urbania on rent in Viman Nagar ideal for family trips, airport transfers, and corporate outings. Features AC interiors, pushback seating, safety features, and professional drivers."
  },
  {
    "name": "17 seater Urbania on rent Viman Nagar",
    "description": "17 seater Urbania on rent in Viman Nagar for larger groups and corporate teams. Luxury AC interiors, spacious seating layout, luggage space, and smooth ride quality."
  },
  {
    "name": "Luxury Urbania hire Viman Nagar",
    "description": "Luxury Urbania hire in Viman Nagar for premium travel requirements. Best suited for executives, weddings, and VIP guests with elegant AC interiors, plush seating, and courteous chauffeurs."
  },
  {
    "name": "AC Urbania Mini Bus hire Viman Nagar",
    "description": "AC Urbania mini bus hire in Viman Nagar offering cool, comfortable, and relaxed journeys. Ideal for all seasons with powerful air-conditioning and clean, spacious interiors."
  },
  {
    "name": "Force Urbania 17 seater Viman Nagar",
    "description": "Force Urbania 17 seater in Viman Nagar for corporate events, airport transfers, family outings, and outstation tours with AC comfort and experienced drivers."
  },
  {
    "name": "Urbania on rent near Phoenix Mall Viman Nagar",
    "description": "Urbania on rent near Phoenix Mall Viman Nagar for shopping trips, airport transfers, and city travel with luxury AC comfort and reliable service."
  },
  {
    "name": "Urbania hire near Symbiosis Viman Nagar",
    "description": "Urbania hire near Symbiosis Viman Nagar for student groups, faculty travel, and events. Spacious AC interiors and punctual drivers ensure smooth travel."
  },
  {
    "name": "Urbania rental near Yerawada Pune",
    "description": "Urbania rental near Yerawada Pune for corporate, family, and airport travel. Comfortable AC vehicles with ample seating and professional drivers."
  },
  {
    "name": "Urbania van hire near Kalyani Nagar",
    "description": "Urbania van hire near Kalyani Nagar for premium city and airport travel. Clean AC interiors, luggage space, and experienced chauffeurs."
  },
  {
    "name": "Urbania on rent near Kharadi IT Park",
    "description": "Urbania on rent near Kharadi IT Park for corporate travel, office pickups, and airport transfers. Ideal for IT professionals with luxury AC comfort."
  },
  {
    "name": "Urbania on rent Viman Nagar for corporate travels",
    "description": "Urbania on rent in Viman Nagar for corporate meetings, conferences, seminars, and employee transportation. Premium AC interiors and disciplined drivers meet corporate standards."
  },
  {
    "name": "Urbania hire Viman Nagar for airport transfer",
    "description": "Urbania hire in Viman Nagar for airport transfers with punctual service, AC comfort, and luggage-friendly vehicles."
  },
  {
    "name": "Urbania on rent Viman Nagar for family trip",
    "description": "Urbania on rent in Viman Nagar for family trips offering safety, comfort, and space. Ideal for vacations, outings, and temple visits."
  },
  {
    "name": "Urbania hire Viman Nagar for outstation",
    "description": "Urbania hire in Viman Nagar for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more with AC comfort and reliable vehicles."
  },
  {
    "name": "Urbania van hire Viman Nagar for wedding",
    "description": "Urbania van hire in Viman Nagar for wedding transportation. Perfect for guest movement and family travel with luxury AC interiors."
  },
  {
    "name": "Urbania hire Viman Nagar per km rate",
    "description": "Urbania hire in Viman Nagar available on per km basis with transparent and competitive pricing for local and outstation travel."
  },
  {
    "name": "Affordable Urbania rental Viman Nagar",
    "description": "Affordable Urbania rental in Viman Nagar offering premium travel at budget-friendly prices without compromising on comfort or service quality."
  },
  {
    "name": "Cheap Urbania on rent Viman Nagar",
    "description": "Cheap Urbania on rent in Viman Nagar for cost-effective group travel with AC comfort and professional drivers."
  },
  {
    "name": "Best Urbania rental service Viman Nagar",
    "description": "Best Urbania rental service in Viman Nagar known for reliability, luxury vehicles, experienced drivers, and high customer satisfaction."
  },
  {
    "name": "Book Urbania on rent in Viman Nagar",
    "description": "Book Urbania on rent in Viman Nagar easily with flexible booking options, luxury AC vehicles, and dependable service."
  },
  {
    "name": "Online Urbania booking Viman Nagar",
    "description": "Online Urbania booking in Viman Nagar for quick and hassle-free reservations with well-maintained AC vehicles and professional chauffeurs."
  },
  {
    "name": "Urbania cab service Viman Nagar",
    "description": "Urbania cab service in Viman Nagar offering premium group transportation for airport, corporate, family, and outstation travel."
  },
  {
    "name": "13 Seater Urbania on Rent in Viman Nagar Pune",
    "description": "13 seater Urbania on rent in Viman Nagar Pune for families and small groups with AC comfort, luggage space, and experienced drivers."
  },
  {
    "name": "Luxury Force Urbania Hire Viman Nagar",
    "description": "Luxury Force Urbania hire in Viman Nagar delivering a premium travel experience with high-end AC interiors and professional chauffeurs."
  },
  {
    "name": "Urbania Airport Transfer Service Viman Nagar Pune",
    "description": "Urbania airport transfer service in Viman Nagar Pune providing timely pickup and drop with AC luxury vehicles and reliable drivers."
  }
],
"tableData": [
  ["Urbania on rent in Viman Nagar Pune", "Force Urbania on rent Viman Nagar"],
  ["Urbania rental service Viman Nagar", "Urbania van hire in Viman Nagar"],
  ["Urbania on rent near Pune Airport", "Urbania Pune Airport pickup Viman Nagar"],
  ["Urbania Pune Airport drop Viman Nagar", "Force Urbania airport transfer Viman Nagar"],
  ["13 seater Urbania on rent Viman Nagar", "17 seater Urbania on rent Viman Nagar"],
  ["Luxury Urbania hire Viman Nagar", "AC Urbania Mini Bus hire Viman Nagar"],
  ["Urbania on rent near Phoenix Mall Viman Nagar", "Urbania hire near Symbiosis Viman Nagar"],
  ["Urbania rental near Yerawada Pune", "Urbania van hire near Kalyani Nagar"],
  ["Urbania on rent Viman Nagar for corporate travels", "Urbania hire Viman Nagar for airport transfer"],
  ["Urbania on rent Viman Nagar for family trip", "Urbania hire Viman Nagar for outstation"],
  ["Urbania van hire Viman Nagar for wedding", "Affordable Urbania rental Viman Nagar"],
  ["Cheap Urbania on rent Viman Nagar", "Best Urbania rental service Viman Nagar"],
  ["Book Urbania on rent in Viman Nagar", "Online Urbania booking Viman Nagar"],
  ["Urbania cab service Viman Nagar", "Urbania Airport Transfer Service Viman Nagar Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Urbania on Rent in Viman Nagar Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania on Rent in Viman Nagar Pune, providing comfortable, stylish, and dependable travel solutions for group travel, corporate trips, and family outings."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and Local Travel",
    "WhyChoosedescription": "Whether it’s a corporate commute, family outing, or local sightseeing, our Urbania rentals in Viman Nagar ensure a smooth and stress-free journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, ample legroom, air conditioning, large windows, and generous luggage space, making them ideal for short city rides and longer trips."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Urbania rentals come with trained and courteous drivers who ensure punctuality, safety, and a pleasant travel experience throughout Viman Nagar and Pune."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Transparency",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Urbania rentals in Viman Nagar, giving you excellent value for money without hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized, maintaining high standards of hygiene, safety, and comfort for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations with customized routes to suit your travel plan within Viman Nagar, Pune, or nearby destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania on Rent in Viman Nagar Pune is simple with Amruta Travels. Our support team assists you at every step for a hassle-free experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania on rent in Viman Nagar Pune?',
    answer: 'You can book an Urbania on rent in Viman Nagar Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate travel from Viman Nagar?',
    answer: 'Yes, Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Viman Nagar.'
  },
  {
    question: 'Can I rent Urbania in Viman Nagar for outstation trips?',
    answer: 'Yes, we provide Urbania rentals from Viman Nagar for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Urbania rental include a driver?',
    answer: 'Yes, every Urbania rental includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain hygiene, safety, and passenger comfort.'
  },
  {
    question: 'What is the cost of Urbania on rent in Viman Nagar Pune?',
    answer: 'The rental cost depends on distance, duration, and type of travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Viman Nagar?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania rental in Viman Nagar Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Aditya Patil',
    role: 'IT Professional, Viman Nagar',
    text: 'We rented an Urbania from Viman Nagar for a corporate trip. The vehicle was comfortable, clean, and the driver was professional. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Shruti Joshi',
    role: 'Family Traveler, Viman Nagar',
    text: 'Booked an Urbania on rent in Viman Nagar for a family outing. The ride was smooth, comfortable, and hassle-free. Highly recommend Amruta Travels!',
    rating: 5
  }
];























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Viman Nagar Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-on-rent-viman-nagar.jpg",
  "description": "Urbania on rent in Viman Nagar Pune with Amruta Travels. Hire 13 & 17 seater Force Urbania vans for airport transfers, corporate travel, family trips, weddings, outstation journeys, and local sightseeing. Service areas include Pune Airport, Phoenix Mall, Symbiosis, Yerawada, Kalyani Nagar, and Kharadi IT Park with professional drivers and affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6300",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-on-rent-viman-nagar"
  }
};


    return (
        <div>



<Helmet>
  <title>Call: +91 7353109555 | Urbania on Rent in Viman Nagar Pune | Force Urbania Hire | Amruta Travels</title>
  <meta
    name="description"
    content="Urbania on rent in Viman Nagar Pune with Amruta Travels. Hire 13 & 17 seater Force Urbania vans for airport transfers, corporate travel, family trips, weddings, and outstation journeys at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/112.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinvimannagar;